// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-data[data-v-3560b4d6]{text-align:center;padding:2rem;color:#6c757d}.select-blue select[data-v-3560b4d6]{border-color:#007bff}.pagination-sm .page-link[data-v-3560b4d6]{cursor:pointer}.pagination-sm .page-item.disabled .page-link[data-v-3560b4d6]{cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
